var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vxe-menu',{ref:"menu",attrs:{"options":_vm.list,"accordion":"","size":"mini"},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }